import { createContext, useContext, useState } from "react";



const clickContext = createContext();

export function ClickProvider ({children}){

    const [click, setClick] = useState(false);

        

    return (
        <clickContext.Provider value={{click, setClick}}>
            {children}
        </clickContext.Provider>
    )
} 

export function useClick () {
    return useContext(clickContext);
}
